import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { DATAHUB_ACTION_BUTTON_WIDTH } from '@/features/DataHub/constants/ui';

export const ExportItemActions = ({
  canDelete,
  canRegenerate,
  isDeleting,
  onDelete,
  onRegenerate
}: {
  canDelete: boolean;
  canRegenerate: boolean;
  isDeleting: boolean;
  onDelete: () => void;
  onRegenerate: () => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 2
      }}
    >
      <Button
        disabled={!canDelete || isDeleting}
        size='small'
        startIcon={<DeleteOutlineIcon />}
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main',
          width: DATAHUB_ACTION_BUTTON_WIDTH
        }}
        variant='outlined'
        onClick={onDelete}
      >
        Delete
      </Button>
      <Button
        disabled={!canRegenerate || isDeleting}
        size='small'
        startIcon={<DownloadIcon />}
        sx={{
          width: DATAHUB_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={onRegenerate}
      >
        Regenerate
      </Button>
    </Box>
  );
};
